import React from 'react';
import posed from 'react-pose';
import styled, { css } from 'styled-components';
import ThemeProvider from './ThemeProvider';
import theme from './theme';
import { Colors } from './colors';
import Media from './media-queries';

export const Theme = ({ children }) => (
  <ThemeProvider>{children}</ThemeProvider>
);

export { styled, css, ThemeProvider, Colors, posed, Media, theme };
